export default "__VITE_ASSET__BwXnbk_4__"